import type { SubmissionVerdictKey } from './getSubmissionVerdictKey';

type PendingBudgetWarningInput = {
  verdict: SubmissionVerdictKey;
  remainingBudgetCents: number | null | undefined;
};

export function shouldShowPendingBudgetExhaustedWarning({
  verdict,
  remainingBudgetCents,
}: PendingBudgetWarningInput): boolean {
  return verdict === 'pending'
    && typeof remainingBudgetCents === 'number'
    && Number.isFinite(remainingBudgetCents)
    && remainingBudgetCents <= 0;
}
